import * as React from 'react'
import { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import { FaroRoute } from '@grafana/faro-react'
import * as config from 'config'
import { ConnectedRouter } from 'connected-react-router'
import { RequireAuth } from 'routes/guards/requireAuth'
import UserPilotScript from 'userPilot'
import GoogleTranslateScript from 'googleTranslate'
import BreakPoint from '../utils/mediaQuery'
import AuthRoutes, { ALL_AUTH_ROUTES } from './auth'
import IntegrationRoutes, { ALL_INTEGRATION_ROUTES } from './integration'
import AppRoutes from './appRoutes'
import { history, navigation } from 'middleware'
import { RequiresCreatedAccount } from 'signUp/requiresCreatedAccount'
import UnauthorizedUserRoutes, { ALL_UNAUTHORIZED_USER_ROUTES } from './unauthorizedUser'
import { PageLoader } from 'uiComponents/loaders'
import { MessagesProvider } from 'messagesContext'

const RouteComponent = config.get('faro-env') ? FaroRoute : Route

const Routes = () => {
    return (
        <Suspense fallback={<PageLoader />}>
            <ConnectedRouter history={history}>
                <MessagesProvider>
                    <BreakPoint>
                        <Switch>
                            <RouteComponent path={ALL_INTEGRATION_ROUTES}>
                                <IntegrationRoutes />
                            </RouteComponent>

                            <RouteComponent path={ALL_UNAUTHORIZED_USER_ROUTES}>
                                <UnauthorizedUserRoutes />
                            </RouteComponent>

                            <RouteComponent path={ALL_AUTH_ROUTES}>
                                <AuthRoutes />
                            </RouteComponent>

                            <RouteComponent>
                                <RequireAuth>
                                    <RequiresCreatedAccount>
                                        <Switch>
                                            <AppRoutes />
                                        </Switch>
                                    </RequiresCreatedAccount>
                                </RequireAuth>
                            </RouteComponent>
                        </Switch>
                        <UserPilotScript history={history} navigation={navigation} />
                        <GoogleTranslateScript />
                    </BreakPoint>
                </MessagesProvider>
            </ConnectedRouter>
        </Suspense>
    )
}

export default Routes
